import React from 'react';

import { Form } from 'components';

const Filters = ({ data, onChange, onClean, onSubmit }) => {
  return (
    <Form className="row form-filters">
      <Form.Field className="col-md-2">
        <Form.Label>Período, de</Form.Label>
        <Form.Icon name="calendar">
          <Form.DatePicker
            dateFormat="dd/MM/yyyy"
            selected={data.start_at}
            onChange={value => onChange("start_at", value)}
          />
        </Form.Icon>
      </Form.Field>

      <Form.Field className="col-md-2">
        <Form.Label>Período, até</Form.Label>
        <Form.Icon name="calendar">
          <Form.DatePicker
            dateFormat="dd/MM/yyyy"
            selected={data.end_at}
            onChange={value => onChange("end_at", value)}
            minDate={data.start_at}
            disabled={data.start_at === null}
          />
        </Form.Icon>
      </Form.Field>

      <Form.Field className="col-md-3">
        <Form.Button className="button-clean-filter" onClick={onClean}>
          Limpar Filtro
        </Form.Button>
        <Form.Button className="button-apply-filter" onClick={onSubmit}>
          Aplicar Filtro
        </Form.Button>
      </Form.Field>
    </Form>
  );
};

export default Filters;
